import { type AvailableIcons } from "~/components/ui/Icon"
import { HTMLWidget } from "~/types/widgets"
import Image from "~/components/ui/Image"
import { TitleIcon } from "~/loaders/TitleIcon"
import { clsx } from "~/sdk/clx"

export interface IconProps {
    /**
     * @title Ícone
     */
    id: AvailableIcons
    /**
     * @title Tamanho
     */
    size: number
    /**
     * @title Cor
     */
    color?: string | null
    /**
     * @title Cor de traço
     */
    stroke?: string | null
    /**
     * @title Grossura do traço
     */
    strokeWidth: number
}

export interface Props {
    /**
     * @title Title
     * @description Generic section title
     */
    title: HTMLWidget
    /**
     * @title Icon
     * @description Icon side decoration
     */
    icon?: TitleIcon
    color?: string
}

const Title = ({ icon, title, color }: Props) => {
    return (
        <div className='flex items-center gap-4 mx-auto px-4'>
            {icon && (
                <Image
                    src={icon.icon}
                    alt={icon.alt}
                    width={icon.width}
                    height={icon.height}
                    loading='lazy'
                />
            )}

            {title && (
                <div
                    className={clsx(
                        'font-light leading-normal text-center text-lg lg:text-4xl uppercase [&_strong]:font-extrabold',
                        !color && 'text-[#91153a] [&_strong]:text-[#e5554f]',
                    )}
                    dangerouslySetInnerHTML={{ __html: title }}
                    style={{ color }}
                />
            )}

            {icon && (
                <Image
                    src={icon.icon}
                    alt={icon.alt}
                    width={icon.width}
                    height={icon.height}
                    loading='lazy'
                />
            )}
        </div>
    )
}

export default Title
